import { Collapse } from 'bootstrap'
import Cleave from 'cleave.js'
import Slideout from 'slideout'
import { tns } from 'tiny-slider/src/tiny-slider'

/**
 * Search form.
 */
const searchToggleButton = document.querySelector('#app-header-search-form button[type="button"]')
searchToggleButton.addEventListener('click', e => {
  e.preventDefault()

  searchToggleButton.parentNode.classList.toggle('active')
  searchToggleButton.parentNode.querySelector('input').focus()
})

const searchSubmitButton = document.querySelector('#app-header-search-form button[type="submit"]')
searchSubmitButton.addEventListener('click', e => {
  if (document.querySelector('#app-header-search-form input').value == '') {
    e.preventDefault()

    searchSubmitButton.parentNode.classList.toggle('active')
  }
})

/**
 * Hero Banner Slideshow.
 * @see https://github.com/ganlanyuan/tiny-slider
 */
if (document.querySelector('.hero-banner .slides')) {
  var slider = tns({
    container: '.hero-banner .slides',
    items: 1,
    slideBy: 'page',
    autoplay: true,
    autoplayButtonOutput: false,
    controls: false,
    nav: false,
    gutter: 5,
    responsive: {
      992: {
        controls: true
      },
      1200: {
        fixedWidth: 1180,
        center: true
      }
    }
  })
}

/**
 * Scroll to element.
 */
var scrollToElements = document.querySelectorAll('[data-scroll-to]')
for (var scrollToElement of scrollToElements) {
  scrollToElement.addEventListener('click', e => {
    e.preventDefault()

    var selector = scrollToElement.dataset.scrollTo
    var offsetTop = document.querySelector(selector).offsetTop
   
    scroll({
      top: offsetTop,
      behavior: "smooth"
    })
  })
}

/**
 * Slideout Nav.
 * https://github.com/mango/slideout
 */
var slideout = new Slideout({
  'panel': document.getElementById('app-panel'),
  'menu': document.getElementById('app-nav-mobile'),
  'padding': 320,
  'tolerance': 70,
  'side': 'right',
  'touch': false
})

document.querySelector('.nav-icon').addEventListener('click', () => {
  slideout.toggle();
})

document.querySelector('#app-nav-mobile .close-icon').addEventListener('click', () => {
  slideout.close();
})

// Sub-menus
document.querySelectorAll('#app-nav-mobile .nav-link').forEach(link => {
  link.addEventListener('click', (e) => {
    if (e.target.getAttribute('href') == '#') {
      var btn = e.target.nextElementSibling
      var myCollapse = document.querySelector(btn.getAttribute('data-bs-target'))
      var bsCollapse = new Collapse(myCollapse, {
        toggle: true
      })
    }
  })
})

/**
 * Mask phone inputs.
 */
document.querySelectorAll('input[type="tel"]').forEach(el => {
  new Cleave(el, {
    numericOnly: true,
    blocks: [0, 3, 0, 3, 4],
    delimiters: ["(", ")", " ", "-"],
  })
})

/**
 * Mask numeric inputs.
 */
document.querySelectorAll('input.numeric, input.currency, input.percentage').forEach(el => {
  new Cleave(el, {
    numeral: true,
    numeralThousandsGroupStyle: 'thousand'
  })
})

/**
 * Modals.
 *
 * Appends the Bootstrap modal backdrop to the app panel
 * so that it is under the modal itself.
 */
var modals = document.querySelectorAll('.modal')
modals.forEach(modal => {
  modal.addEventListener('show.bs.modal', e => {
    var backdrop = document.createElement('div')
    backdrop.classList.add('modal-backdrop', 'fade', 'show')
    document.querySelector('#app-panel').appendChild(backdrop)
  })

  modal.addEventListener('hidden.bs.modal', e => {
    var backdrop = document.querySelector('.modal-backdrop')
    backdrop.parentNode.removeChild(backdrop)
  })
})
